import { isObject } from 'radash';

export const isUndefined = (value: unknown): value is undefined => typeof value === 'undefined' || value === undefined;

export const isNull = (value: unknown): value is null => value === null;

export const isEmptyOrNull = (value: unknown): value is null => value === null || value === undefined || value === '';

export const isArray = (value: unknown) => (Array.isArray(value) ? value : []);

export const isObjectArray = (array: unknown): array is object[] => {
  return Array.isArray(array) && array.length > 0 && typeof array[0] === 'object' && array[0] !== null;
};

export const isValueObjectArray = (val: unknown): val is { value: string | null | undefined }[] =>
  Array.isArray(val) && val.every((item) => typeof item === 'object' && item !== null && 'value' in item);

export const isIdObjectArray = (val: unknown): val is { id: string }[] =>
  Array.isArray(val) && val.every((item) => typeof item === 'object' && item !== null && 'id' in item);

export const isObjectEmpty = (value: unknown): boolean => {
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0;
  }
  return false;
};

export const isStringArray = (val: unknown): val is string[] => {
  return Array.isArray(val) && val.every((item) => typeof item === 'string');
};

export const isRecord = (value: unknown): value is Record<string, unknown> => isObject(value) && value !== null;
